/*
    当前项目接口环境
*/
export const YJJ_ENV = 'prod';  // api环境: local  dev  test  prod  casicloud

// 航天云网：
// 'http://106.74.18.237:26091'
// 'http://yjj-api.paas.casicloud.com'

/* 
	各种环境的接口地址
*/

/* 衣加加接口前缀 */ 
const yjjApi = {
    local: '',
    dev: 'https://api.dev.ysintelligent.com/yijiajia_app',  // 'http://10.10.1.123:10011',
    test: 'https://api.test.ysintelligent.com/yijiajia_app',
    prod: 'https://api.ysintelligent.com/yijiajia_app',
    casicloud: 'http://106.74.18.237:26091', // '/casicloud-api-yjj',
}
/* 支付接口前缀 */
const yjjPayApi = {
    local: '',
    dev: 'https://api.dev.ysintelligent.com/yijipay',
    test: 'https://api.test.ysintelligent.com/yijipay',
    prod: 'https://api.ysintelligent.com/yijipay',
    casicloud: 'https://api.dev.ysintelligent.com/yijipay',
}

/* 图片前缀 */
const imgPrev = {
    local: 'https://static.dev.ysintelligent.com',
    dev: 'https://static.dev.ysintelligent.com',
    test: 'https://static.test.ysintelligent.com',
    prod: 'https://static.ysintelligent.com',
    casicloud: '/static',
}

/* 订货系统接口前缀 */
const orderingApi = {
    local: '',
    dev: 'https://api.dev.ysintelligent.com',
    test: 'https://api.test.ysintelligent.com',
    prod: 'https://api.ysintelligent.com',
    casicloud: 'https://api.dev.ysintelligent.com',
}

/* 数聚时尚连接地址 */
const sjssUrl = {
    local: '',
    dev: 'https://e.dev.fzzht.com/#',
    test: 'https://e.test.fzzht.com/#',
    prod: 'https://e.fzzht.com/#',
    casicloud: 'https://e.dev.fzzht.com/#',
}

/* 数字云仓 接口前缀 */
const dwApi = {
    local: '',
    dev: 'https://api.dev.ysintelligent.com/digital_warehouse',
    test: 'https://api.test.ysintelligent.com/digital_warehouse',
    prod: 'https://api.ysintelligent.com/digital_warehouse',
    casicloud: 'http://106.74.18.237:30847', // '/casicloud-api-dw' // 'http://dw-api.paas.casicloud.com',
}
// 管理后台 -生产加工模块接口地址
const produceApi = {
    local: '',
    dev: 'https://api.dev.ysintelligent.com/yijiajia_admin/p/',
    test: 'https://api.test.ysintelligent.com/yijiajia_admin/p/',
    prod: 'https://api.ysintelligent.com/yijiajia_admin/p/',
    casicloud: 'https://api.dev.ysintelligent.com/yijiajia_admin/p/',
}
const bujuyun={
    local: '',
    dev: 'https://api.dev.ysintelligent.com/bujuyun',
    test:'https://api.test.ysintelligent.com/bujuyun',
    prod: 'https://api.ysintelligent.com/bujuyun',
    casicloud: 'https://api.dev.ysintelligent.com/bujuyun',
}




export const API_PREFIX = {
    yjjApi: yjjApi[YJJ_ENV],             // 衣加加接口前缀
    yjjPayApi: yjjPayApi[YJJ_ENV],       // 支付接口前缀
    imgPrev: imgPrev[YJJ_ENV],           // 图片前缀
    orderingApi: orderingApi[YJJ_ENV],   // 订货系统接口前缀  - 未使用
    sjssUrl: sjssUrl[YJJ_ENV],           //数聚时尚连接地址  - 未使用
    dwApi: dwApi[YJJ_ENV],               // 数字云仓 接口前缀
    produceApi:produceApi[YJJ_ENV],    // 管理后台 -生产加工模块
    bujuyun:bujuyun[YJJ_ENV]    // 布局云的接口
}

